import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import useFirebase from "../../hooks/useFirebase";
import { toast, ToastContainer } from "react-toastify";
import { injectStyle } from "react-toastify/dist/inject-style";

if (typeof window !== "undefined") {
  injectStyle();
}

const MyOrders = () => {
  const { user } = useFirebase();
  const [orders, setOrders] = useState([]);

  //fetch
  useEffect(() => {
    let mounted = true;
    fetch(`https://young-hamlet-12954.herokuapp.com/${user?.email}/myOrders`)
      .then((res) => res.json())
      .then((data) => {
        if (mounted) {
          setOrders(data);
          //console.log("i fire once");
        }
      });
    return () => (mounted = false);
  }, [user.email]);

  // delete
  const deleteOrder = (product) => {
    const proceed = window.confirm("Are you sure you want to delete?");
    if (proceed) {
      fetch(
        `https://young-hamlet-12954.herokuapp.com/deleteMyOrder/${product}`,
        {
          method: "DELETE",
          headers: { "content-type": "application/json" },
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.deletedCount > 0) {
            const remaining = orders.filter((bk) => bk.product !== product);
            setOrders(remaining);
            toast.dark("Deleted successfully!");
          }
        });
      //console.log("deleted", product);
    }
  };
  return (
    <div className="container mt-2 w-75">
      <h1 className="text-center fw-bold">My Orders</h1>
      <Table striped bordered hover responsive>
        <thead>
          <tr className="text-center">
            <th>#</th>
            <th>Product Name</th>
            {/* <th>Booked Date</th> */}
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {orders?.map((bk, index) => (
            <tr className="text-center" key={bk._id}>
              <td>{index + 1}</td>
              <td>{bk?.product}</td>
              {/* <td>{bk?.date}</td> */}
              <td>{bk?.status}</td>
              <td className="text-center">
                <button
                  onClick={() => {
                    deleteOrder(bk?.product);
                  }}
                  className="btn btn-delete p-2 text-white"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <ToastContainer />
    </div>
  );
};

export default MyOrders;
